import React, { useState,useRef,useEffect } from 'react';
import './App.css';
import 'animate.css';
import { Button,Modal } from 'react-bootstrap';
import axios from "axios";
import {Helmet} from "react-helmet";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import FacebookLogin from 'react-facebook-login';
import {reactLocalStorage} from 'reactjs-localstorage';
import {useLocation} from "react-router-dom";
function ShareFnc() {
  const [users,setUsers] = useState({})
  const [login, setLogin] = useState(false);
  const [data, setData] = useState({});
  const [picture, setPicture] = useState("");
  const url = 'https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/share';
  const componentClicked = () => {}
  const search = useLocation().search;
  const fb_id = new URLSearchParams(search).get('fb_id');
  const img_id = new URLSearchParams(search).get('imgid');
  let imageUrl = "https://www.goodyear.co.th/assurance-maxguard-suv/services/uploads/score/"+img_id+".png"
  console.log(imageUrl);
  const responseFacebook = (response) => {
    console.log(response);
    if (response.status === "unknown") {
      alert("Login failed!");
      setLogin(false);
      return false;
    }
    setData(response);
    setPicture(response.picture.data.url);
    reactLocalStorage.set('popimg', response.picture.data.url)
    reactLocalStorage.setObject('profile',response)
    if (response.accessToken) {
      setLogin(true);
      let bodyFormData = new FormData();
      bodyFormData.append('fb_id', response.id);
      bodyFormData.append('fb_name', response.name);
      bodyFormData.append('fb_email', response.email);
      bodyFormData.append('score', 0);
      axios({
        method: "post",
        url: "https://www.goodyear.co.th/assurance-maxguard-suv/services/api/V1/join",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          window.location.href="/pumptire"
          console.log(response.data);
        })
        .catch(function (response) {
          //handle error
          console.log(response);
        });
     
    } else {
      setLogin(false);
    }
  }
  
  useEffect(() => {
    axios.get(url).then(res => {
      setUsers(res.data)
      console.log(res.data);
    })
  }, [])
  return (
    <div className="shareContainer">
        <Helmet>
        <title>PUMPTIRE - GOOD YEAR ASSURANCE MAXGUARD SUV</title>
        <meta name="description" content="คะแนนของ คุณ xxx xxxx คือ 900,000 เราขอท้าให้ท่านเข้าร่วมแข่งขันกิจกรรมกับเรา" />
        <meta name="ogtitle" property="og:title" content="PUMPTIRE - GOOD YEAR ASSURANCE MAXGUARD SUV" />
        <meta property="og:type" ontent="website"/>
        <meta property="og:image" content={imageUrl}/>
        <meta property="og:description" content="คะแนนของ คุณ xxx xxxx คือ 900,000 เราขอท้าให้ท่านเข้าร่วมแข่งขันกิจกรรมกับเรา" />
        </Helmet>
        <video autoPlay muted loop className="bg-video">
        <source src={`${(isMobile)?"../mobile_bg.mp4":"../bg.mp4"}`} type="video/mp4"/>
      </video>
        <div className="sharebox">
            <img src={imageUrl}/>
            <FacebookLogin
                  appId="921615008736175"
                  autoLoad={false}
                  fields="name,email,picture"
                  callback={responseFacebook}
                  cssClass="join_poptire joinnow" 
                  version="2.3"
                  onClick={()=>componentClicked()}
                  textButton="เข้าร่วมกิจกรรม"
                />
        </div>
    </div>
  );
}
export default class Share extends React.Component{
    render(){
      return(
        <ShareFnc/>
      )
    }
  }
  
